import { AxiosError } from "axios";

export const is404ResponseStatus = (error: unknown) => {
  return (error as AxiosError)?.response?.status === 404;
};